export default __webpack_public_path__ + "static/media/ic_spei.406dbd9e.svg";